import actionTypes from 'constants/actionTypes';
import Immutable from 'immutable';

const initialState = Immutable.Map().merge({
    openBankToken: '',
    error: '',
    isLoggedIn: false,
    errorCount: 0,
});

export const loginRobo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_ROBO_LOGIN_SUCCESS:
            return state.merge({
                isLoggedIn: action.payload.isLoggedIn,
            });

        case actionTypes.RA_ROBO_LOGIN_FALIURE:
            return state.merge({
                error: action.payload.error,
                errorCount: state.get('errorCount') + 1,
            });

        case actionTypes.RA_ROBO_LOGIN_RESET_ERRORS:
            return state.merge({
                error: action.payload,
            });

        default:
            return state;
    }
};
